/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Or_DividerInputs */

const en_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or`)
};

const fr_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

const de_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder`)
};

const it_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O`)
};

const ru_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или`)
};

const es_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o`)
};

const zh_cn2_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或者`)
};

const ja_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`または`)
};

const hi_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`या`)
};

const pt_pt2_login_or_divider = /** @type {(inputs: Login_Or_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ou`)
};

/**
* | output |
* | --- |
* | "or" |
*
* @param {Login_Or_DividerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_or_divider = /** @type {((inputs?: Login_Or_DividerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Or_DividerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_or_divider(inputs)
	if (locale === "de") return de_login_or_divider(inputs)
	if (locale === "it") return it_login_or_divider(inputs)
	if (locale === "ru") return ru_login_or_divider(inputs)
	if (locale === "es") return es_login_or_divider(inputs)
	if (locale === "zh-CN") return zh_cn2_login_or_divider(inputs)
	if (locale === "ja") return ja_login_or_divider(inputs)
	if (locale === "hi") return hi_login_or_divider(inputs)
	if (locale === "pt-PT") return pt_pt2_login_or_divider(inputs)
	return en_login_or_divider(inputs)
});